document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.wholesale-program');

  sections.forEach((section) => {
    const track = section.querySelector('.wholesale-track');
    const slides = section.querySelectorAll('.wholesale-card');
    const prevBtn = section.querySelector('.wholesale-prev');
    const nextBtn = section.querySelector('.wholesale-next');

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;
    let visibleSlides = window.innerWidth < 990 ? 1 : 2;

    function getSlideWidth() {
      const slide = slides[0];
      const gap = parseInt(getComputedStyle(track).gap) || 0;
      return slide.offsetWidth + gap;
    }

    function maxIndex() {
      return Math.max(slides.length - visibleSlides, 0);
    }

    function updateSlider() {
      const move = currentIndex * getSlideWidth();
      track.style.transform = `translateX(-${move}px)`;

      if (currentIndex <= 0) {
        prevBtn.style.opacity = '.5';
        prevBtn.style.pointerEvents = 'none';
      } else {
        prevBtn.style.opacity = '1';
        prevBtn.style.pointerEvents = 'auto';
      }

      if (currentIndex >= maxIndex()) {
        nextBtn.style.opacity = '.5';
        nextBtn.style.pointerEvents = 'none';
      } else {
        nextBtn.style.opacity = '1';
        nextBtn.style.pointerEvents = 'auto';
      }
    }

    nextBtn.addEventListener('click', () => {
      if (currentIndex < maxIndex()) {
        currentIndex++;
        updateSlider();
      }
    });

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });

    window.addEventListener('resize', () => {
      visibleSlides = window.innerWidth < 990 ? 1 : 2;

      if (currentIndex > maxIndex()) {
        currentIndex = maxIndex();
      }

      updateSlider();
    });

    /* touch swipe mobile */
    let startX = 0;
    let endX = 0;

    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      endX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', () => {
      const diff = startX - endX;

      if (diff > 50 && currentIndex < maxIndex()) {
        currentIndex++;
        updateSlider();
      }

      if (diff < -50 && currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });

    updateSlider();
  });
});